import { render } from "./ManagementRole.vue?vue&type=template&id=34f04836"
import script from "./ManagementRole.vue?vue&type=script&lang=js"
export * from "./ManagementRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__